import { Toast as ToastBW } from 'baseui/toast';
import { IDummyProps } from './types';
import { Link } from '../Link';
import { notificationActionStyle, notificationExternalLinkStyle, notificationTextStyle } from './styles';
import { overrides as customOverrides } from './overrides';
import { Button } from '../Button';
import { styled, useStyletron } from '../../Themes';
import { mergeOverrides } from 'baseui';
import React from 'react';

type EpoType = IDummyProps;

export const View = React.forwardRef((props: EpoType, ref: any) => {
	const [css] = useStyletron();
	const { overrides, ...rest } = props;
	const limit = 200;
	let textToShow = props.text;
	if (typeof props.text == 'string') {
		if (props.text.length > limit) {
			textToShow = props.text.substring(0, limit) + '...';
		}
	}

	return (
		<ToastBW
			ref={ref}
			{...rest}
			kind={undefined}
			overrides={overrides ? mergeOverrides(customOverrides(rest), overrides as any) : customOverrides(rest)}
		>
			{props.title && (
				<div>
					<h4 className={css({ marginTop: 'var(--epods--space-inset-s)', color: 'var(--epods--color-text-primary)' })}>{props.title}</h4>
				</div>
			)}
			<span style={notificationTextStyle}>{textToShow}</span>
			{props.children}
			{(props.externalLink || props.link) && (
				<div style={notificationActionStyle}>
					{props.externalLink &&
						<Button
							className={css(props.link ? (notificationExternalLinkStyle as any) : undefined)}
							theme="tertiary"
							onClick={props.externalLink.action ? props.externalLink.action : undefined}
						>
							{props.externalLink.text}
						</Button>
					}
					{props.link &&
						<Link
							href={props.link.url ? props.link.url : undefined}
							onClick={props.link.action ? props.link.action : undefined}
							tabIndex={0}
						>
							{props.link.text}
						</Link>
					}
				</div>
			)}
		</ToastBW>
	);
});

export const NotificationFooter = styled('div', ({ $theme }: any) => {
	return {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 'var(--epods--space-inset-m)',
		width: '100%',
	};
});
